import {
  PERMISSIONS_FETCH_START,
  PERMISSIONS_FETCH_SUCCESS,
  PERMISSIONS_FETCH_FAIL,
  SET_MESSAGE,
  LOGOUT,
} from "./types";
import adminPermissionsService from "../services/adminPermissions.service";
import AuthService from "../services/auth.service";
import { flattenApiBody } from "../../helpers/flattenApiBody";

export const fetchAdminPermissions = () => (dispatch) => {
  dispatch({ type: PERMISSIONS_FETCH_START });
  return adminPermissionsService
    .getMePermissions()
    .then((res) => {
      const payload = flattenApiBody(res.data);
      dispatch({
        type: PERMISSIONS_FETCH_SUCCESS,
        payload,
      });
      return payload;
    })
    .catch((err) => {
      const status = err?.response?.status;
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Could not load permissions";
      dispatch({
        type: PERMISSIONS_FETCH_FAIL,
        payload: { message, status },
      });
      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });
      if (status === 401 || status === 403) {
        AuthService.logout();
        dispatch({ type: LOGOUT });
        return Promise.reject(err);
      }
      return Promise.resolve(null);
    });
};
